import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DictionaryItem, DictionaryResponse } from 'voxloud-types/dist/models/ai-assistant/index';

@Injectable()
export class AiAssistantService {
  
  constructor(private http: HttpClient) { }

  public getDictionary(idPage: any, size: any, key: string): Observable<DictionaryResponse> {
    let params = new HttpParams()
    .append('page', idPage)
    .append('size', size)
    .append('key', key);
    return this.http.get<DictionaryResponse>(`${environment.apiEndpoint}/api/v1/ai/dictionary`, { params });
  }

  public addDictionary(payload: DictionaryItem): Observable<DictionaryItem> {
    return this.http.post<DictionaryItem>(`${environment.apiEndpoint}/api/v1/ai/dictionary`, payload);
  }

  public updateDictionary(payload: DictionaryItem): Observable<DictionaryItem> {
    return this.http.put<DictionaryItem>(`${environment.apiEndpoint}/api/v1/ai/dictionary/${payload.id}`, payload);
  }
  
  public deleteDictionary(payload: DictionaryItem): Observable<any> {
    return this.http.delete<any>(`${environment.apiEndpoint}/api/v1/ai/dictionary/${payload.id}`);
  }
}